import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const card = "rounded-lg bg-card p-8 text-center shadow-md border border-border";

const errorTitle = "mb-2 text-xl font-bold text-foreground";

const errorDescription = "mb-4 text-muted-foreground";

const reloadBtn = cn(shared.primaryButton, "rounded-md py-2");

export { card, errorTitle, errorDescription, reloadBtn };
